import { Box, useMediaQuery } from "@mui/material";
import Logo from "./components/logo";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Page404 from "./components/Page404"
import PageTerm from "./components/PageTerm"
import Footer from "./components/Footer"
import PagePolicy from "./components/PagePolicy"
import PagePolicyCookie from "./components/PagePolicyCookie"
import PageSuccess from "./components/PageSuccess"
import PageReject from "./components/PageReject"
import ScrollToTop from "./components/ScrollToTop";
import PageContacts from "./components/PageContacts";
import PageSupport from "./components/PageSupport";
import PageSupportChat from "./components/PageSupportChat";
import GamePage from "./components/GamePage";
import HomePage from "./components/HomePage";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setUser } from "./store/slice/userSlice";
import { check } from "./http/userAPI"
import Account from "./components/Account"
import AccountMain from "./components/Account/AccountMain";
import AccountSell from "./components/Account/AccountSell"
import AccountTransactions from "./components/Account/AccountTransactions"
import MainNav from "./components/MainNav.js";
import { createContext } from 'react';
import { useTheme } from '@mui/material/styles'
import PageConfyrm from "./components/PageConfyrm.js";
import ServiceModal from './components/ServiceModal.js'

export const LayoutContext = createContext({
  isMobile: false
});

const App = () => {

  const dispatch = useDispatch()
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm')) // мобильный экран
  const isMobileLandscape = useMediaQuery(
    '(max-width:1000px) and (orientation: landscape)'
  );

  useEffect(() => {
    check().then(data => {
      if (data) {
        dispatch(setUser(data))
      }
    })

  }, [dispatch])

  return (
    <LayoutContext.Provider value={{ isMobile }}>
    <BrowserRouter>
      <ScrollToTop />
      <Box className="wrap">
        <Box className="topBar"
          display="flex"
          justifyContent="center"
          alignItems="center"
          gap={2}
          p={2}>
        
        <ServiceModal />
          <Box>
            <Logo isMobile={isMobile} />
          </Box>
        </Box>

        <MainNav isMobile={isMobile} />

        <Box>
          <Routes>
            <Route path='/' element={<HomePage />} />
            <Route path='/term-and-conditions' element={<PageTerm />} />
            <Route path='/policy' element={<PagePolicy />} />
            <Route path='/cookie-policy' element={<PagePolicyCookie />} />
            <Route path='/contacts' element={<PageContacts />} />
            <Route path='/support' element={<PageSupport />} />
            <Route path='/support-chat' element={<PageSupportChat />} />
            <Route path='/support-chat/:chatId' element={<PageSupportChat />} />
            
            
            <Route path='*' element={<Page404 />} />
            <Route path='/pay-success/:orderId' element={<PageSuccess />} />
            <Route path='/pay-confyrm/:orderId' element={<PageConfyrm />} />
            <Route path='/pay-reject' element={<PageReject />} />
            <Route path='/account' element={<Account />}>
              <Route path="" element={<AccountMain />} />
              <Route path="sell" element={<AccountSell />} />
              <Route path="transactions" element={<AccountTransactions />} />

            </Route>
            <Route path='/game/:gameId' element={<GamePage />} />


          </Routes>
        </Box>

        {
          !isMobile && <Footer />
        }

        
      </Box>
    </BrowserRouter>
    </LayoutContext.Provider>
  )
}

export default App;
